import React from 'react';
import { HistoryHebrewItem, HistoryItem, PricesTabType } from 'store/state/selectors/insights/prices';
import { TableColumn } from 'ds/components/table';
import { useLocale } from 'locale';
import { ColumnRendererProps, PricesTableColumn } from '../../../utils';
import { HistoryPricesColumn, PricesContent, PriceLabel } from './styled';
import HistoryAgentColumn from './agent-column';
import { getEnforcedSiValue } from '../../../../utils';

export const getHistoryPriceColumnConfig = (isMobile: boolean, tabId: PricesTabType): Partial<TableColumn<HistoryItem>> => ({
  sortFn: (items: HistoryItem[]) => items.sort((a, b) => b.price - a.price),
  width: isMobile ? '60%' : (tabId === PricesTabType.Unit ? '28%' : '15%'),
  gap: isMobile ? 0 : 16,
  align: 'right',
});

export const HistoryPriceColumn: React.FC<ColumnRendererProps<HistoryItem | HistoryHebrewItem>> = props => {
  const { item, isMobile, tabId } = props;
  const { formatMoneyWithMetricPrefix } = useLocale();

  return (
    <HistoryPricesColumn col={PricesTableColumn.Price}>
      <PricesContent>
        {isMobile && tabId !== PricesTabType.Unit ? (<HistoryAgentColumn item={item as HistoryHebrewItem}/>) : null}
        <PriceLabel caps>
          {formatMoneyWithMetricPrefix(item.price, 2, getEnforcedSiValue(item.price))}
        </PriceLabel>
      </PricesContent>
    </HistoryPricesColumn>
  );
};
